import { setLocale } from 'react-redux-i18n';
import { useDispatch } from 'react-redux';
import { supportedLanguageCodes } from '@helpers/languages';

export function useTranslation(langChoice: string): void {
    const dispatch = useDispatch();
    const localStorageLanguage = window.localStorage.getItem('language');
    // when language is not set for user,default is english
    if (supportedLanguageCodes.includes(langChoice) && localStorageLanguage !== langChoice) {
        window.localStorage.setItem('language', langChoice);
        dispatch(setLocale(langChoice));
    }
}
